/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../../payments/set_metadata';
import '../common/common';
import '../../common/emv';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "esperanto": {
        "nested": {
          "api": {
            "nested": {
              "SetMetadataRequest": {
                "fields": {
                  "paymentId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "requestId": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "delayCaptureReason": {
                    "type": "squareup.payments.api.DelayCaptureReason",
                    "id": 3,
                    "rule": "optional"
                  },
                  "billInfo": {
                    "type": "squareup.esperanto.common.BillInfo",
                    "id": 4,
                    "rule": "optional"
                  },
                  "clientStoreAndForwardCreatedAtMs": {
                    "type": "int64",
                    "id": 5,
                    "rule": "optional"
                  },
                  "emvCaptureTags": {
                    "type": "squareup.common.EmvTags",
                    "id": 6,
                    "rule": "optional"
                  }
                }
              },
              "SetMetadataResponse": {
                "fields": {
                  "status": {
                    "type": "squareup.esperanto.common.OperationStatus",
                    "id": 1,
                    "rule": "optional"
                  },
                  "error": {
                    "type": "squareup.payments.api.SetMetadataResponse.Status",
                    "id": 2,
                    "rule": "optional"
                  },
                  "paymentId": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.esperanto?.nested?.api?.nested?.SetMetadataRequest && !$root.nested?.squareup?.nested?.esperanto?.nested?.api?.nested?.SetMetadataResponse) {
  $root.addJSON(jsonData);
}

/**
 * Sets metadata for a particular payment, such as bill flow specific info or delayed capture
 * reason, etc.
 *
 * SOURCE SetMetadataRequest @ squareup/esperanto/api/set_metadata.proto at 16:1
 */
export const SetMetadataRequest = $root.lookupType('squareup.esperanto.api.SetMetadataRequest');
fixType(SetMetadataRequest, {
  paymentId: {
    required: true
  }
});
Builder.createAndAttachToType(SetMetadataRequest);
/**
 * SOURCE SetMetadataResponse @ squareup/esperanto/api/set_metadata.proto at 41:1
 */
export const SetMetadataResponse = $root.lookupType('squareup.esperanto.api.SetMetadataResponse');
fixType(SetMetadataResponse);
Builder.createAndAttachToType(SetMetadataResponse);